<template>
    <div class="animated fadeIn"> 
      <b-row>
        <b-col sm="12"> 
          <b-card>
            <div slot="header">
              <strong> Damage/ Shortage/ Isexcess </strong>
                 
             </div>       
            <b-row>  
                <b-col sm="7">
                    <div id='container'>
                        <b-form-group label="Warehouse ID" :label-cols="3">
                            <div id='container'>
                                <ejs-multiselect  id='multi_select2'  placeholder="Select WareHouse" v-model="valueWH" :dataSource='optionsWH' :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All"    :fields='fieldWH' :allowCustomValue='allowCustomValue'  enableGroupCheckBox="true" mode="CheckBox" 
                                ></ejs-multiselect>
                            </div>    
                        </b-form-group>
                    </div>
                </b-col>   
                <b-col sm="5">
                    <b-form-group label="Select Hub" :label-cols="4">
                        <b-form-select  v-model="selectedhub">
                            <option :value="select">-- Select Hub --</option>
                            <option :value="hub.hubid" v-for="hub in hubItems"  :key="hub.hubid" >{{hub.hubname}} - {{hub.hubid}}</option>
                        </b-form-select>
                    </b-form-group>
                </b-col>       
            </b-row>   

            <b-row>  
                <b-col sm="4">
                  <b-form-group label="Shipment Status:"  :label-cols="5" >
                    <b-form-select name="shipmentstatus" class="mySelectBox" v-model="shipmentstatus">
                      <option :value="selected">--Selected Status-</option>
                      <!-- <option value="HandoverPending">Handover Pending</option> -->

                      <option value="NDR">NDR</option>
                      <option value="INTransit">IN Transit</option>
                      <option value="Delivered">Delivered</option>
                      <option value="BookingDone">Booking Done</option>
                      <option value="OFD">OFD</option>
                      <option value="ZoneInScan">Zone In Scan</option>
                      <option value="ZoneOutScan">Zone Out Scan</option>
                      <option value="DockInScan">Dock In Scan</option>
                      <option value="DockOutScan">Dock Out Scan</option>
                      <option value="DispatchOutScan">Dispatch Out Scan</option>
                      <option value="HubInScan">Hub In Scan</option>
                    </b-form-select>                                
                  </b-form-group>                   
                </b-col>    

                <b-col sm="4">
                    <b-col sm="12">
                        <b-form-group label="From Date:"  :label-cols="4" >
                        <v-date-picker mode='single' input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectDateFrom' @input="clearToDate">
                        </v-date-picker>
                        </b-form-group>
                    </b-col>
                </b-col>

                <b-col sm="4">
                    <b-form-group label="To Date:"  :label-cols="3" >
                        <v-date-picker mode='single' input-class="dateInput" :available-dates="toDateRange" v-model='selectDateTo'>
                        </v-date-picker>
                        <!-- :available-dates='{ start: null, end: new Date() }' -->
                    </b-form-group>
                </b-col>

                <!-- <b-col md="4" class="my-1">
                  <b-form-group >                           
                    <b-form-textarea v-model.trim="searching" style="height:100px" placeholder="Type to Search : 1023,Test"></b-form-textarea>                                           
                  </b-form-group>
                  <div>
                    <span style="color:red">Note:For Multiple Search Use comma(,) Separator </span>
                  </div>
                </b-col> -->
  
                <b-col md="5" class="my-1">
                    <b-form-group label="Select Damage/ Shortage/ Isexcess :"  :label-cols="7" >
                      <b-form-select
                      v-model="selected_damashort"
                      :options="damashoroptions"
                      class="mb-3"
                      value-field="value"
                      text-field="text"
                      ></b-form-select>
                    </b-form-group>
                </b-col>
  
                <b-col md="4" class="my-1 text-right">               
                  <b-form-group>
                   <b-button type="submit" size="md" variant="primary" @click="showLoadwise(1)"> Search</b-button>
                 
                    <b-button type="submit" size="md" variant="danger" @click="clear()" style="margin-left: 10px"> clear</b-button>
                    &nbsp;
                    <a :href="loadurl" target="_blank" v-if="totalRows>0" >
                        <b-button variant="primary" @click="downlaodloadurl">Download</b-button>
                    </a>
                   
                  </b-form-group>
                </b-col>
            </b-row>
              
            <b-row>
                <b-col sm="12" class="text-right" >
                  <b>Total Records :<span style="color:red;">{{totalRows }}</span></b>   &nbsp;&nbsp;&nbsp;
                </b-col>
            </b-row>        
          
            <b-col sm="12">  
              <b-table show-empty  responsive :busy="isBusy" :items="items" :fields="fields"  :current-page="currentPage"  :per-page="perPage" :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc" :sort-direction="sortDirection"  @filtered="onFiltered" :bordered="bordered"  > 
                  
                  <div slot="table-busy" class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                  <template slot="marked_on" slot-scope="row">
                    <div>
                        {{ row.item.marked_on | ConvertTime12hour() }}
                    </div>
                  </template>
                  <template slot="markdeliverystatusflag" slot-scope="row">
                    <span v-if="row.item.markdeliverystatusflag == '1'">
                      Yes
                    </span>
                    <span v-else>
                      No
                    </span>
                  </template>
                  <template slot="damage_image" slot-scope="row">
                    <div>
                      <b-button variant="light" style="padding: 1px 6px;" :title="row.item.mpsno" @click="showDamegeimage(row.item.mpsno)">
                        <i class="fa fa-eye" aria-hidden="true"></i>
                      </b-button>
                    </div>
                  </template>
              </b-table>
            </b-col>
  
            <b-col md="12" class="my-1" v-if="totalRows>0">
              <paginate :page-count="noofpages"
                :page-range="10"
                :margin-pages="2"
                :click-handler="clickCallback"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :container-class="'pagination'"
                :page-class="'page-item'">
              </paginate>
            </b-col>

            <b-modal size="md" v-model="damageimg" :title="`Damaged MPS No.` + ' - ' + damageMPSno" hide-footer>
              <div id="listloader" v-if="loader">
                  <div class="listloader"></div>
              </div>
              <div v-if="damageitem.length>0" class="text-center mb-3">
                  <div v-for="i in damageitem">
                      <span v-if="i.defective_imageurl">
                           <img :src="i.defective_imageurl" alt="Damage Image" style="width: 100%;">
                      </span>
                      <span v-else>
                           Damage Image Not Found
                      </span>
                   </div>
              </div>
              <div v-else class="text-center mb-3">
                  Damage Image Not Found
              </div>
          </b-modal>
          </b-card>
        </b-col>
      </b-row>    
    </div>
  </template>
<script>
  import CONSTANTS from "@/utils/constants";
  import Utils from "@/utils";
  import Vue from 'vue'
  export default {
    data: function() {
      return{
        loader:false,
        valueWH:[],
        fieldWH:{ text: 'name', value: 'id' },
        optionsWH:[],
        WHData:[],
        hubItems:[],
        selectedhub:'',
        select :'',
        selected : '',
        shipmentstatus : '',
        selectDateFrom : new Date(),
        selectDateTo : new Date(),
        selected_damashort : 'damage',
        damashoroptions : [
            { value: 'damage', text: 'Damage' },
            { value: 'shortage', text: 'Shortage' },
        ],
        pageNum:1,
        noofpages:'',
        items : [],
        fields: [
          { key: 'loadid', label: 'Load Id', sortable: true, sortDirection: 'desc' },
          { key: 'Damage_Or_Shortage', label: 'Damage/Shortage/Isexcess', sortable: true, sortDirection: 'desc' },
          { key: 'mpsno', label: 'MPS No.', sortable: true, sortDirection: 'desc' },
          { key: 'Bag_no', label: 'Bag No', sortable: true, sortDirection: 'desc' },
          { key: 'invoicevalue', label: 'Invoice Value', sortable: true, sortDirection: 'desc' },
          { key: 'mpsvalue', label: 'MPS Value',sortable: true, sortDirection: 'desc' },
          { key: 'shippingreferenceno', label: 'Shipping Reference No', sortable: true},
          { key: 'Shipment_Status', label: 'Shipment status', sortable: true, sortDirection: 'desc' },
          { key: 'shippingcompany', label: 'Shipping Company', sortable: true},
          { key: 'userid', label: 'User ID', sortable: true},
          { key: 'sourcecompanyname', label: 'Source Company Name', sortable: true, sortDirection: 'desc' },
          { key: 'dest_city', label: 'Destination City', sortable: true, sortDirection: 'desc' },
          { key: 'vehicle_no', label: 'Vehicle No.', sortable: true, sortDirection: 'desc' },
          { key: 'Hub/Rider', label: 'Hub / Rider', sortable: true, sortDirection: 'desc' },
          { key: 'marked_at', label: 'Marked AT', sortable: true, sortDirection: 'desc' },
          { key: 'damage_image', label: 'Damage Box Image', sortable: true, sortDirection: 'desc' },
          { key: 'marked_by', label: 'Marked By', sortable: true, sortDirection: 'desc' },
          { key: 'marked_on', label: 'Marked On', sortable: true, sortDirection: 'desc' },
          { key: 'SB_Flag', label: 'SB Flag', sortable: true, sortDirection: 'desc' },
          { key: 'sb_flag_removed_on', label: 'SB flag removed on', sortable: true, sortDirection: 'desc' },
          { key: 'sb_flag_removed_by', label: 'SB flag removed By', sortable: true, sortDirection: 'desc' }

        ],
        bordered: true,
        totalRows: 0,
        currentPage: 1,
        perPage:  20,
        loadurl : '',
        damageimg:false,
        damageMPSno:'',
        damageitem:[]
      };
    },
    created: function() {
     
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      this.showWHlist();
      this.hubListing();
      this.showLoadwise(this.pageNum);
    },
    computed: {
        toDateRange() {
          if (!this.selectDateFrom) {
            // If "From Date" is not selected, allow any date up to today
            return { start: null, end: new Date() };
          }
          // Calculate 60 days from the selected "From Date"
          const fromDate = new Date(this.selectDateFrom);
          const maxDate = new Date(fromDate);
          maxDate.setDate(maxDate.getDate() + 60);

          // Ensure the "end" does not exceed today's date
          const today = new Date();
          console.log('fromDate----->',fromDate,'toDate------->', maxDate < today ? maxDate : today )
          return { start: fromDate, end: maxDate < today ? maxDate : today };
        },
    },
    methods: {
        
        downlaodloadurl(){
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
            var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";
                this.loadurl=`${CONSTANTS.MIGRATION_API_URL}/getShortageOrDamagedOrExcessMPSBoxesCSVDownload?is_damage_shortage_excess=`+this.selected_damashort+`&warehouseids=`+this.valueWH+`&hub_id=`+this.selectedhub+`&shipmentstatus=`+this.shipmentstatus+`&from_date=`+fromdate+`&to_date=`+formatdateto;

            console.log("this.loadurl",this.loadurl)
            // getCSVForAllocatedLoadsListing?page_no=`+this.listingpageno+`&&`+`sysusermasterid=`+userInfo.sysusermasterid+`&&`+`usertype=`+userInfo.user_type+`&&`+`for_status=`+`Assigned`+`&&`+`payloadArr=`+this.searchvaluesarr+`&&`+`is_asn=`+(this.route_id == 'normal' ? 'NO': 'YES')
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },
    
        formatDate: function(date) {
            var d = new Date(date),
            month = "" + (d.getMonth() + 1),
            day = "" + d.getDate(),
            year = d.getFullYear();
            if (month.length < 2) month = "0" + month;
            if (day.length < 2) day = "0" + day;
            return [year, month, day].join("-");
    
        },
        
        showWHlist:function(){
          
            var userdata = localStorage.getItem('userData')
            var userInfo = JSON.parse(userdata)
            
            var csvObj = {};
            console.log("JJJJJ",csvObj);
          
          
            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getWarehouselisting`, csvObj)
              .then(result => {
                
                if (result.body.returnmsg === 'Successful') {
                        this.optionsWH=[];
                    
                        this.WHData  = result.body.returnvalue;
                        console.log("HHHHHHH",this.WHData)
                        
                    for(let j = 0; j < this.WHData.length; j++) {
                        let WH = {
                        name: this.WHData[j].fcsourceid + " - " + this.WHData[j].warehousename,
                        id: this.WHData[j].fcsourceid,
                    }
                    this.optionsWH.push(WH);
                }
                    
                } else {
                
                    this.WHData  = result.body.returnvalue;
                    
                }
  
            })
            .catch(ex => {
                    console.log("error-----", ex);
            });
        },
  
        hubListing(){
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            const obj={
                sysusermasterid:`${userInfo.sysusermasterid}`,
                usertype : `${userInfo.user_type}`,
            }
            console.log("objlist",obj)
            this.$http
                .post(
                `${ CONSTANTS.MIGRATION_API_URL}/getAllHubListing`,obj).then(result => {
                    if (result.body.returnmsg === "Successful") {
                    this.hubItems=result.body.returnvalue;
                    console.log("aaaaaaaa",this.hubItems);
                    
                    }else{
                    this.hubItems=[];
                    }
            }).catch(ex => {
                console.log("error", ex);
            });
        },

        clickCallback (pageNum){

            this.showLoadwise(pageNum);
        },

        showLoadwise: function(page) {
          this.items  = [];
          this.totalRows = 0;         
          this.isBusy = true;
            //date
            var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
            var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";

            if(!formatdateto){
              this.$fire({
                        text:"Please select to date!",
                        type: "warning",
                        timer: 30000
                    }); 
                    this.isBusy = false; 
                    return false;  
            }
            if(formatdateto< fromdate){  
                this.$fire({
                        text:"To date need to be greater than From date",
                        type: "warning",
                        timer: 30000
                    }); 
                    this.isBusy = false; 
                    return false;       
            }

            //warehouse id and shipmentstatus
            var warehouseid=(this.valueWH.length>0)? this.valueWH:"";
            var shipmentstatus=(this.shipmentstatus!=null)?this.shipmentstatus:"";

            var userdata = localStorage.getItem('userData')
            var userInfo = JSON.parse(userdata)
            
               
                var csvObj = {

                  is_damage_shortage_excess : this.selected_damashort,
                  hub_id : this.selectedhub,
                  from_date: `${fromdate}`,
                  to_date:`${formatdateto}`,
                  warehouseids:warehouseid,
                  shipmentstatus:`${shipmentstatus}`,
                  page_no:`${page}`,
                };
                
            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getShortageOrDamagedOrExcessMPSBoxes`, csvObj)
                .then(result => {
                
                    this.isBusy = false;

                if (result.body.returnmsg  === 'Successful') {
                    this.items  = result.body.returnvalue;
                    this.totalRows = result.body.totalcount;  
                    this.noofpages=parseInt(this.totalRows)/20;
                    
                    this.noofpages=Math.ceil( this.noofpages);  
                }else{
                    this.items  = [];
                    this.totalRows = 0;               
                    
                }
                })
                .catch(ex => {
                console.log("error-----", ex);
                });
        },

        clear(){
            this.valueWH = [];
            this.selectedhub = '';
            this.shipmentstatus = '';
            this.selectDateFrom = new Date();
            this.selectDateTo = new Date();
            this.selected_damashort = 'damage';
            this.showLoadwise(this.pageNum);
        },

        showDamegeimage: function (data){
            this.loader=true;
            this.damageimg = true;
            this.damageMPSno = '';
            this.damageitem =[];
            this.damageMPSno = data;
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            const Obj = {
                mpsno: this.damageMPSno 
            }

            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getDamagedBoxImage`,Obj).then(
            (result) =>{
                this.loader=false;
                if (result.body.returnmsg==='Successful') {
                    this.damageitem = result.body.returnvalue;
                } else {
                    this.damageitem =[];
                }
            })
            .catch((er)=>
            {})
        },
        clearToDate(){
          console.log('kakk')
          this.selectDateTo = null;
        }
    }
  };
  </script>
  


  